module.exports = __webpack_public_path__ + "static/media/caries.007c29f6.svg";